import type { EligibleSubsidy } from "@/features/subventions/types/subvention.types";
import { type LimitCard, limitCards } from "@/features/subventions/utils/subventionStatus";

// `cards` lets a caller that already derived the list (to gate rendering) pass it in, avoiding a
// second limitCards() pass; omit it and the grid derives its own.
type LimitCardGridProps = { subsidy: EligibleSubsidy, cards?: LimitCard[] };

// Per-period caps (monthly/quarterly/…) with the active window when current_periods is present.
export const LimitCardGrid = ({ subsidy, cards: providedCards }: LimitCardGridProps) => {
  const cards = providedCards ?? limitCards(subsidy);
  if (!cards.length) return null;

  return (
    <div className="flex flex-wrap gap-2.5">
      {cards.map((card) => (
        <div
          key={card.period}
          className="min-w-[130px] rounded-xl border border-gray-200 bg-gray-50 px-3 py-2.5 dark:border-gray-700 dark:bg-gray-800/50"
        >
          <div className="text-[10.5px] font-bold uppercase tracking-wide text-gray-400 dark:text-gray-500">
            {card.period}
          </div>
          <div className="mt-0.5 text-base font-extrabold tabular-nums text-gray-900 dark:text-white">
            {card.cap}
          </div>
          {card.window && (
            <div className="mt-0.5 text-[10.5px] text-gray-400 dark:text-gray-500">{card.window}</div>
          )}
        </div>
      ))}
    </div>
  );
};

LimitCardGrid.displayName = "LimitCardGrid";
